import {AccessTime} from '@material-ui/icons';
import React from 'react';

interface IExpireOrangeIconProps {
  disabled?: boolean;
}

export function ExpireOrangeIcon({disabled}: IExpireOrangeIconProps) {
  return <AccessTime fontSize="small" style={{opacity: disabled ? 0.3 : 1, color: '#FF8C00'}} />;
}
